export default async function (to, from, next, store) {
    if (!store.getters['auth/csrfInitiated']) {
        store.dispatch('auth/csrf');
    }

    return true;
};
